import { domainService } from '@/apis/domain.s';

const state = {
  message: {
    color: '',
    dialog: false,
    content: '',
  },
};

const getters = {
  domainMessage: state => state.message,
};

const mutations = {
  SET_MESSAGE(state, data) {
    state.message = data;
  },
};

const actions = {
  setMessage({ commit }, data) {
    commit('SET_MESSAGE', data);
  },

  async connectDomain({ dispatch }, dataPost) {
    try {
      await domainService.connect(dataPost);
      dispatch('setMessage', { color: 'success', dialog: true, content: 'Connected successfully' });
      return true;
    } catch (error) {
      console.log('🚀 ~ file: domain.js ~ connectDomain ~ error:', error);
      dispatch('setMessage', { color: 'red', dialog: true, content: error });
      return false;
    }
  },

  async connectDomainCloudflare({ dispatch }, dataPost) {
    try {
      await domainService.connectCloudflare(dataPost);
      dispatch('setMessage', { color: 'success', dialog: true, content: 'Connected via Cloudflare successfully' });
      return true;
    } catch (error) {
      console.log('🚀 ~ file: domain.js:10 ~ connectDomainCloudflare ~ error:', error);
      dispatch('setMessage', { color: 'red', dialog: true, content: error });
      return false;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
